import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environment/environment';
import { BillingAccessService } from '../components/billing-&-invoice/billing-access.service';

/**
 * Guard that blocks Billing when the feature flag is off or the user lacks Billing view access.
 */
export const billingModuleGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (environment.enableBillingModule !== true) {
    return router.createUrlTree(['/dashboard', 'home']);
  }
  // const rbac = inject(RbacService);
  // if (!rbac.hasFinanceModuleAccess()) {
  //   return router.createUrlTree(['/dashboard', 'home']);
  // }
  const billingAccess = inject(BillingAccessService);
  billingAccess.refresh();
  if (!billingAccess.canView()) {
    return inject(Router).createUrlTree(['/dashboard', 'home']);
  }
  return true;
};
